export const MESSAGE_TYPES = {
    COMMENT: 'Comment',
    MESSAGE: 'message',
    SYSTEM: 'System',
    INFORMATION: 'information',
    SYSTEM_OUTBOUND: 'System - Outbound',
    SYSTEM_INBOUND: 'System - Inbound'
};
